import axios from 'axios'
import util from '../comm/util.js'


let http = axios.create({
  // baseURL:'http://192.168.210.173:8080/mobile/',
  withCredentials: true,
  headers: {
    'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'
    // 'Content-Type':'multipart/form-data'
  },
  transformRequest: [function (data) {
    let newData = '';
    for (let k in data){
      if (data.hasOwnProperty(k) === true) {
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return newData;
  }]
});

var ajax = {
  ajax:function (obj) {
    http({
      method: obj.method,
      url: obj.url,
      data: obj.data ,
      params:  obj.params ,
    }).then(function (res) {
      if(res.data && res.data == 'reset'){
        // let href = window.location.href;
        // var url = href.split('#')[0] + '#/login';
        // window.location.href = url;
        util.util.goLogin();
        return;
      }else{
        obj.success(res);
      }
    }).catch(function (err) {
      obj.error(err);
    })
  },
  get:function (url,data,success,error,complete) {
    this.ajax({
      method:'GET',
      url:url,
      params:data,
      success:success||function(){},
      error:error||function(){},
      complete:complete||function(){},
    });
  },
  post:function (url,data,success,error,complete) {
    this.ajax({
      method:'POST',
      url:url,
      data:data,
      success:success||function(){},
      error:error||function(){},
      complete:complete||function(){},
    });
  },
};

export default { ajax }



// WEBPACK FOOTER //
// ./src/comm/ajax.js